<template>  
  <v-data-table
    :headers="headers"
    :items="rows"
    item-key="id"
    class="tablaT1"
    :class="dark_t?'dark':''">
    <template v-slot:item="props">
      <tr>
        <td :style="`background-color:${dark_t?'black':'white'}`" v-if="!readOnly">
          <slot name="delete" v-bind:item="props.item"></slot>
        </td>
        <td style="text-align:left !important">
          <fs1-span>{{props.item.name}}</fs1-span>
        </td>
        <td style="text-align:left !important">
          <fs1-span>{{props.item.related_asi_area}}</fs1-span>
        </td>
        <td style="text-align:left !important">
          <fs1-span>{{props.item.owner_full_name}}</fs1-span>
        </td>
        <td>
          <fs1-span v-if="props.item.link">
            <a :href="props.item.link" target="_blank">
              <v-icon>insert_drive_file</v-icon>
            </a>
          </fs1-span>
        </td>
        <td :style="`background-color:${dark_t?'black':'white'}`" v-if="!readOnly">
          <slot name="edit" v-bind:item="props.item"></slot>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: ['rows','readOnly'],
  computed: {
    headers() {
      const name = { text: 'Nombre', sortable: false, value: 'name' };
      const related_asi_area = { text: 'Área', sortable: false, value: 'related_asi_area' };
      const owner_full_name = { text: 'Dueño', sortable: false, value: 'owner_full_name' };
      const file = { text: 'Archivo', sortable: false, value: 'file' };
      return this.readOnly
      ? [name, related_asi_area, owner_full_name, file]
      : [
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
				name, related_asi_area, owner_full_name, file,
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
      ];
		},
  },
};
</script>
